<template>
  <div class="camera">
    <!-- 拍照-->
    <el-card>
      <div style="height: 20px;font-weight: 600;font-size: 14px">摄像头</div>
      <!-- 摄像头-->
      <video id="video" :width="canvasWidth" :height="canvasHeight" style="transform: scaleX(-1)"></video>
      <!-- 偷拍的照片-->
      <canvas id="camera" style="display:none;"  :width="canvasWidth" :height="canvasHeight"></canvas>
    </el-card>
  </div>
</template>

<script>
  export default {
    name: "Camera",
    props: {
      courseId: String, // 课程id
      sectionId: String, // 小节id
    },
    data() {
      return {
        // 摄像机
        video: null,
        camera: null,
        context: null,
        canvasWidth: '160',
        canvasHeight: '160',
        isOpenCamera: false,
        isOpenCameraAndQuestion: true,
        imgSrcObj: [],
      }
    },
    methods: {
      // 打开摄像机
      openCamera() {
        this.video = document.getElementById('video');
        this.camera = document.getElementById('camera');
        //this.canvas.getContext('2d').clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.context = this.camera.getContext('2d');
        let that = this;
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia === undefined) {
          navigator.mediaDevices.getUserMedia = (constraints) => {
            const getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
            if (!getUserMedia) {
              return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
            }
            return new Promise((resolve, reject) => {
              getUserMedia.call(navigator, constraints, resolve, reject);
            });
          }
        }
        const constraints = { audio: false, video: { width: this.canvasWidth, height: this.canvasHeight} };
        navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
          if ('srcObject' in that.video) {
            that.video.srcObject = stream
          } else {
            that.video.src = window.URL.createObjectURL(stream)
          }
          that.video.onloadedmetadata = (e) => {
            that.video.play();
            that.isOpenCamera = true;
          }
        }).catch(err => {
          console.log(err)
        })
      },
      // 抓拍图片并且上传
      async takePhotoAndUpload() {
        this.context.drawImage(this.video, 0, 0, this.canvasWidth, this.canvasHeight);
        const imgSrc = this.camera.toDataURL('image/jpeg');

        let params = new FormData();
        params.append("file", this.dataURLtoFile(imgSrc, `zhuapai.jpg`));
        params.append("courseId",this.courseId);
        params.append("sectionId",this.sectionId);
        let config = { headers: { "Content-Type": "multipart/form-data" } };
        await this.$http.post('/business/web/photograph/upload', params, config);
      },
      // 转换抓拍图片格式
      dataURLtoFile (dataUrl, filename) {
        let  arr = dataUrl.split(',');
        let  mime = arr[0].match(/:(.*?);/)[1];
        let  bstr = atob(arr[1]);
        let n = bstr.length;
        let  u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
      },
    },
    mounted() {
      //打开摄像头
      this.openCamera();
    }
  }
</script>

<style scoped>
  .camera {
    position: fixed;
    top: 100px;
    right:5px;
    text-align: center;
    z-index: 300;
  }
  .el-card {
    width: 160px;
    height: 180px;
    padding: 5px;
    background-color:  #ccc;
    border-radius: 6px;
  }
  .el-card >>> .el-card__body {
    padding: 0px;
    /*height: 160px;*/
  }
</style>
